import L from "leaflet";
import { Marker } from "react-leaflet";
import { MeasurementSite } from "../../../services/RuteplanAPI";
import measurementSiteIconResource from "../../../assets/thermometer.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const measurementSiteIcon = L.icon({
    iconUrl: measurementSiteIconResource,
    iconRetinaUrl: measurementSiteIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IMeasurementSiteMarkersProps {
    measurementSites: Array<MeasurementSite>;
}

export default function MeasurementSitesMarkers (props: IMeasurementSiteMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { measurementSites } = props;

    return (
        <>
            {measurementSites && measurementSites.map((measurementSite: MeasurementSite, index: number) => {
                return (
                    <Marker key={measurementSite.id + index} 
                    position={[measurementSite.location!.y, measurementSite.location!.x]} 
                    icon={measurementSiteIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(measurementSite);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}